import React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Message from './Message';
import { inputShadow } from '../../../sharedStyles';


const StyledTextArea = styled.textarea<{ isError: boolean | undefined }>`
  height: 300px;
  width: 100%;
  max-width: 500px;
  border-radius: 5px;
  padding: 10px 20px 10px 20px;
  outline: none;
  border: ${({ isError, theme }) => (isError ? `3px solid ${theme.colors.cwCoral}` : 'none')};
  color: ${({ isError, theme }) => (isError ? theme.colors.cwCoral : theme.colors.darkGray)};
  margin: 10px 0;
  resize: none;
  ${inputShadow};
`;

interface FieldTextAreaProps {
  name: string,
  placeholder: string,
  config?: UseFieldConfig<string>,
}

const FieldTextArea = ({
  name,
  placeholder,
  config,
  ...otherProps
}: FieldTextAreaProps) => {
  const { input, meta } = useField(name, config);
  const { t } = useTranslation();

  return (
    <>
      <StyledTextArea
        type="text"
        placeholder={placeholder}
        isError={(meta.error && meta.touched && true)}
        {...input}
        {...otherProps}
      />
      <Message
        isVisible={(meta.error && meta.touched && true)}
        type="error"
      >
        {t(meta.error)}
      </Message>
    </>
  );
};

export default FieldTextArea;
